import type { AuctionCar } from '@autobid/ui/types/Car'

export function getAmountOfOwners(eq: AuctionCar['equipments']) {
  return eq.eq24
}
